import React from "react";
import Tooltip from "@mui/material/Tooltip";
// import { Typography } from "@mui/material";
import { BsInfoCircleFill } from "react-icons/bs";
import { Button } from "@mui/material";

function WhatIseDNA() {
  return (
    <Tooltip
      disableFocusListener
      enterTouchDelay={0}
      leaveTouchDelay={5000}
      title={
        <React.Fragment>
          {/* <Typography color="inherit"></Typography> */}
          <br />
          <b className="text-[20px] p-4">EmotionalDNA</b>
          <p className="text-[16px] p-4">
            The Radar Chart you see is eDNA’s <em>Emotional Signature</em>. It’s
            a graphic representation of how audiences respond to content.
            <br />
            Through factor analysis, 36 different attributes are distilled into
            8 distinct dimensions, giving every show and movie its own unique
            signature.
          </p>
          <br />
        </React.Fragment>
      }
    >
      <Button>
        <p
          className="flex gap-x-1 items-center
                       italic text-sm font-semibold normal-case
                       text-white md:text-gray-600
                       hover:cursor-pointer"
        >
          <BsInfoCircleFill /> What is this?
        </p>
      </Button>
    </Tooltip>
  );
}

export default WhatIseDNA;
